// Presentation overrides keep database-backed course and workshop artwork consistent
// with the site's editorial illustrations without changing product records.
const pageArt = (name: string) => `site/editorial/20261019/${name}`
const blogArt = (slug: string) => `blog/editorial/20261019/${slug}`

export const homepageHeroImage = 'blog/editorial/homepage-terminal-v2-20261019-01a1544e'

// Only reviewed cutouts use background removal; article covers keep their paper.
const transparentArtwork = new Set([
  'courses', 'workshops', 'about', 'cypress-core', 'cypress-api',
  'cypress-typescript', '99-cypress-tips'
].map(pageArt))

export const isTransparentEditorialImage = (src: string): boolean => transparentArtwork.has(src)

// These cutouts already have alpha, with the colored collage paper restored.
// Deliver them directly so automatic removal cannot erase those pieces again.
const colorPreservedArtwork: Record<string, string> = Object.fromEntries([
  'tutoring', 'content-authoring', 'consulting', 'consulting-process',
  'product-feedback', 'community-research', 'private-workshops',
  'newsletter', 'speaking-policy'
].map(name => [pageArt(name), `site/editorial/20261020/services/${name}-color-cutout`]))

const replacements: Record<string, string> = {
  small_square_kdhln0: pageArt('about'),
  courses_p3h8ht: pageArt('courses'),
  workshops_ii41od: pageArt('workshops'),
  envelope_1_ssdhpx: pageArt('newsletter'),
  subscribed_mff56j: pageArt('subscribed'),
  speaker_utkj00: pageArt('speaking-policy'),
  privacy_policy_zgjz3g: pageArt('privacy-policy'),
  trelloapp_eeakvw: pageArt('trello-setup'),
  '2023-12-08_11-20-18_bga48t': pageArt('tutoring'),
  'how-it-works_pnwtmi': pageArt('consulting-process'),
  'early-product-feedback_ruchqv': pageArt('product-feedback'),
  conferences_wxzgys: pageArt('community-research'),
  core_workshop_2_q9fzxv: pageArt('cypress-core'),
  'api-workshop_axjhrw': pageArt('cypress-api'),
  'ts-workshop_kibeky': pageArt('cypress-typescript'),
  '99_tips_improved_imta25': pageArt('99-cypress-tips'),
  'web-automation-with-cursor_fikeog': blogArt('cursor-playwright-tips'),
  knolling_vrhtct: pageArt('workshops'),
  magnifying_glas_zpnzd9: blogArt('cypress-basics-selecting-elements'),
  blueprint_zmke74: blogArt('how-to-structure-a-big-project-in-cypress'),
  tricycle_whgyxo: pageArt('cypress-core'),
  rocket_cxeqeq: pageArt('cypress-api'),
  cypress_dk7ilc: blogArt('playing-with-experimental-network-stubbing'),
  'egh_vue-cypress_2000_sru1si': blogArt('cypress-basics-check-if-element-exists'),
  course88_qchyjc: pageArt('cypress-core'),
  course89_cltecz: blogArt('lesser-known-cypress-tricks'),
  course76_vlucnj: pageArt('cypress-typescript'),
  'Screenshot_2024-11-10_at_09.15.38_sivqay': pageArt('cypress-core'),
  images_hhb1uw: pageArt('workshops')
}

export const resolveEditorialImage = (src: string): string => {
  const key = src.replace(/^\/+/, '').replace(/\.(png|jpe?g|webp)$/i, '')
  const resolved = replacements[key] || src
  return colorPreservedArtwork[resolved] || colorPreservedArtwork[key] || resolved
}
